import React, { useState } from "react";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import "../styles/Navbar.css";
import { Menu, Close } from "@mui/icons-material";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className={`navbar ${menuOpen ? "menu-open" : ""}`}>
      <p>{"< " + "Keyur G K" + " />"}</p>
      {menuOpen ? (
        <Close onClick={toggleMenu} className="menu-icon" />
      ) : (
        <Menu onClick={toggleMenu} className="menu-icon" />
      )}
      <div className={`navbar_menu ${menuOpen ? "open" : ""}`}>
        <ScrollLink
          to="home"
          smooth={true}
          duration={500}
          onClick={() => setMenuOpen(false)}
          className="options"
        >
          Home
        </ScrollLink>
        <ScrollLink
          to="about"
          smooth={true}
          duration={500}
          onClick={() => setMenuOpen(false)}
          className="options"
        >
          About
        </ScrollLink>

        <ScrollLink
          to="projects"
          smooth={true}
          duration={500}
          onClick={() => setMenuOpen(false)}
          className="options"
        >
          Projects
        </ScrollLink>
        <ScrollLink
          to="blogs"
          smooth={true}
          duration={500}
          onClick={() => setMenuOpen(false)}
          className="options"
        >
          Blogs
        </ScrollLink>
        <button>
          <a href="https://drive.google.com/file/d/17F7dDcEk9J0K1nbo6_1QNSql7otd7X6f/view?usp=drive_link">
            Resume
          </a>
        </button>
      </div>
    </div>
  );
};

export default Navbar;
